import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LineChartComponent from './../Components/LineChartComponent.jsx';

import Row from 'react-bootstrap/lib/Row';

export default class AcquisitionLineChartComponent extends Component {

  static propTypes = {
    deviceData: PropTypes.object.isRequired,
    deviceName: PropTypes.string
  };

  render() {

    const deviceData = this.props.deviceData;

    if (this.props.deviceName === '')
    {
      return null;
    }

    else {
      const deviceName = this.props.deviceName;
      const series = [];
      const lines = [];
      const labels = [];
      const data = deviceData.get(deviceName);
      const runs = data.length;


      const dataSet = [data];

      for (let i = 0; i < runs; i++) {
        labels.push(i.toString());
      }

      series.push({
        'label' : deviceName,
        'backgroundColor' : '#4d004d',
        'borderColor' : '#4d004d'
      });

      lines.push({
        xAxisValue: '0',
        color: '0AF'
      });

      return (
        <Row style={{ height: 1300, width: 1300, padding: 20 }}>
          <LineChartComponent
            series={series}
            data={dataSet}
            labels={labels}
            lines={lines}
            orphanPointRadius={4}
          />
        </Row>
      );
    }
  }
}




// WEBPACK FOOTER //
// src/Components/AcquisitionLineChartComponent.jsx